/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import 'vs/workbench/services/keybinding/browser/keyboardLayouts/en.linux';
import 'vs/workbench/services/keybinding/browser/keyboardLayouts/es.linux';
import 'vs/workbench/services/keybinding/browser/keyboardLayouts/de.linux';
import 'vs/workbench/services/keybinding/browser/keyboardLayouts/fr.linux';
import 'vs/workbench/services/keybinding/browser/keyboardLayouts/ru.linux';

export { KeyboardLayoutContribution } from 'vs/workbench/services/keybinding/browser/keyboardLayouts/_.contribution';